import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const LogoContainer = styled.div`
  padding: ${props => props.padding};
`;

const AmpelmannTextLogo = ({padding}) => (
  <LogoContainer padding={padding}>
    <img src="/assets/textLogo.svg" alt="Ampelmann logo with title"/>
  </LogoContainer>
);

AmpelmannTextLogo.propTypes = {
  padding: PropTypes.string
};

AmpelmannTextLogo.defaultProps = {
  padding: '0',
};

export default AmpelmannTextLogo;

